import type { FlowName } from "./FlowName";
import type { State } from "./State";

export type Onboarding = Record<FlowName, State>;
// @ts-expect-error ts-migrate(2741) FIXME: Property 'myGrails' is missing in type '{}' but re... Remove this comment to see the full error message
export const empty: Onboarding = {};
